<template>
    <Modal :title="$t('labels.currency')" size="xs" ref="modal" @onHide="hide">
        <div class="modal-body">
            <FieldSet :title="$t('labels.basic_information')">
                <FormGroup :label="$t('labels.name')">
                    <Autocomplete
                        :url="currenciesUrl"
                        :query-params="{ignore_uuids: attachedCurrencyUuids}"
                        :model-value="currency.uuid"
                        :selected-value="currency.name"
                        @update:model-value="selectedCurrency => currency = selectedCurrency"
                    />
                </FormGroup>
                <FormGroup :label="$t('labels.rate')">
                    <Input v-model="rate" type="number"/>
                </FormGroup>
                <FormGroup :label="$t('labels.main_currency')">
                    <CheckBox v-model="main"/>
                </FormGroup>
            </FieldSet>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="teal" @click="create">
                {{ $t('buttons.add') }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from '../../../../../components/new/modal/AppModal.vue';
import FieldSet from '../../../../../components/new/AppFieldset.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Autocomplete from '../../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import Input from '../../../../../components/new/form/Input.vue';
import CheckBox from '../../../../../components/new/form/checkbox/AppCheckbox.vue';
import Button from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';
import { generateUrl } from '../../../../../utils';

export default {
    name: "AddCurrencyModal",
    components: {
        Modal, FieldSet, FormGroup, Autocomplete, Input, CheckBox, Button
    },
    emits: ['created'],
    data() {
        return {
            currenciesUrl: generateUrl('list/currencies'),
            currency: {
                id: null,
                uuid: '',
                name: ''
            },
            rate: null,
            main: false,
            attachedCurrencyUuids: []
        }
    },
    methods: {
        show(attachedCurrencyUuids) {
            this.attachedCurrencyUuids = attachedCurrencyUuids;
            this.$refs.modal.show();
        },
        hide() {
            this.currency = {id: null, uuid: '', name: ''};
            this.rate = null;
            this.main = false;
            this.attachedCurrencyUuids = [];
            this.$refs.modal.hide();
        },
        create() {
            httpClient.post('/settings/basic/currencies', {
                currency_id: this.currency.id,
                main: this.main,
                rate: this.rate
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.added', {
                    model: this.$t('labels.currency')
                }));

                this.hide();
                this.$emit('created');
            })
        }
    }
}
</script>
